import React from "react";
import styles from "./Feedback.module.css";
import { Typography } from "@mui/material";
import AppButton from "component/button/AppButton";
import SuccessIcon from "component/successIcon/SuccessIcon";
import FailIcon from "component/failIcon/FaiIcon";
import InfoIcon from "component/infoIcon/InfoIcon";

function Feedback({
  btnText,
  feedbackState,
  secondaryText,
  handleClickBtn,
  secondaryBtn,
  handleClickSecondaryBtn,
}) {
  return (
    <div className={styles.feedback}>
      <div className={styles.icon}>
      {feedbackState === "success" &&  <SuccessIcon/>}
        {feedbackState === "error" &&     <FailIcon/>}
        {feedbackState === "info" &&   <InfoIcon/>}
      </div>
      <div className={styles.text}>
        <Typography variant="h6">{feedbackState}</Typography>
        <Typography>{secondaryText}</Typography>
      </div>
      <div className={styles.btn}>
        <AppButton
          handleAction={() => {
            handleClickBtn();
          }}
          height="42px"
          fullwidth
          textColor="#FFFFFF"
          btnBg="#0072CE"
          btnText={btnText}
        />

        {secondaryBtn && (
          <div className={styles.btn}>
            <AppButton
              handleAction={() => {
                handleClickSecondaryBtn();
              }}
              fullwidth
              textColor="black"
              btnBg="white"
              btnText={"Close"}
            />
          </div>
        )}
      </div>
    </div>
  );
}

export default Feedback;
